import React, { useState, useRef, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import Form from "react-validation/build/form";
import Tooltip from "@tippyjs/react";
import CheckButton from "react-validation/build/button";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "tippy.js/dist/tippy.css";
import { useForm } from "react-hook-form";
import { ToastContainer, toast } from "react-toastify";

import { getTrans as t } from "../../../Localization/translations";
import Helper from "../../../Helper";
import ButtonLoading from "../../../components/Loder/buttonLoading";
import { API } from "../../../backend";
import TaxRatesService from "../../../services/accounting/taxrateService";

function AddTaxRate() {
  let navigate = useNavigate();
  const [zipcode, setZipCode] = useState("");
  const [taxregion, setTaxRegion] = useState("");
  const [combinedrate, setCombinedRate] = useState(0);
  const [staterate, setStateRate] = useState(0);
  const [countyrate, setCountyRate] = useState(0);
  const [cityrate, setCityRate] = useState(0);
  const [specialrate, setSpecialRate] = useState(0);
  const [startDate, setStartdate] = useState(new Date());
  const [endDate, setEndDate] = useState(null);
  const [TaxState, setTaxState] = useState([]);
  const [state, setStateid] = useState("");

  const checkBtn = useRef();
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();
  const form = useRef();

  const [loading, setLoading] = useState(false);
  const [disable, setDisable] = useState(false);

  const dateplace_Date = (value) => {
    setStartdate(value);
    reset({
      startDate: value,
    });
  };

  const enddateplace_Date = (value) => {
    setEndDate(value);
    reset({
      enddate: value,
    });
  };

  const handleRegister = () => {
    setLoading(true);
    setDisable(true);
    form.current.validateAll();
    let Date = null;
    let enddate = null;
    let combined = 0
    if (checkBtn.current.context._errors.length === 0) {
      if (startDate) {
        Date = Helper.DatePicker(startDate);
      } else {
        setStartdate(startDate);
      }

      if (endDate) {
        enddate = Helper.DatePicker(endDate);
      } else {
        enddate = null;
      }

      // combined = parseFloat(staterate) + parseFloat(cityrate) + parseFloat(specialrate) + parseFloat(countyrate)

      TaxRatesService.TaxrateAdd(
        state,
        zipcode,
        taxregion,
        combined,
        staterate,
        cityrate,
        specialrate,
        countyrate,
        Date,
        enddate
      ).then((response) => {
        if (response.data.success) {
          toast.success(`${response.data.response}`, {
            position: "top-right",
            autoClose: 1000,
            hideProgressBar: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          setLoading(false);
          setTimeout(() => {
            setDisable(false);
            navigate("/taxrateview");
          }, 2000);
        } else {
          setLoading(false);
          setDisable(false);
          toast.error(`${response.data.error}`, {
            position: "top-right",
            autoClose: 1000,
            hideProgressBar: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        }
      })
    }
  };

  useEffect(() => {
    // if (TaxCoutryId !== "") {
    const getstate = async () => {
      const resst = await fetch(API + "helper/ajax/load-states/" + 231 + "/");
      const getst = await resst.json();
      setTaxState(await getst);
    };
    getstate();
    reset({
      startDate: startDate,
    });
    // }
  }, []);

  const handlestate = (event) => {
    const getstateid = event.target.value;
    setStateid(getstateid);
  };

  return (
    <>
      <div>
        <div className="container-fluid pt-2 ">
          <ToastContainer />
          <div className="header pb-0 mb-3">
            <h5 className="tc">{t("Add Tax Rate")}</h5>
          </div>
          <div className="card" role="document">
            <div className="card-body">
              <div className="row">
                <Form
                  role="form text-left"
                  onSubmit={handleSubmit(handleRegister)}
                  ref={form}
                  action="."
                  method="POST"
                  id="addPartyForm"
                >
                  {
                    <>
                      <div className="form-group row">
                        <div className="col-sm-6">
                          <label className="col-form-label required">
                            {t("State")}{" "}
                            <Tooltip content={t("State_Tooltip")}>
                              <i className="fa fa-light fa-circle-info"></i>
                            </Tooltip>
                          </label>
                          <div className="flex-grow-1 me-3 mb-3">
                            {/* <label htmlFor="state">State</label> */}
                            <select
                              name="state"
                              className="form-control"
                              {...register("state", {
                                onChange: (e) => {
                                  //  trigger();
                                  handlestate(e);
                                },
                                required: true,
                              })}
                            >
                              <option value="">---Select State---</option>
                              {TaxState.map((resst) => (
                                <option key={resst.id} value={resst.id}>
                                  {resst.name}
                                </option>
                              ))}
                            </select>
                            <div className="invalid-feedback">
                              {errors.state?.type === "required" &&
                                "State is required"}
                            </div>
                          </div>
                        </div>
                        <div className="col-sm-6">
                          <label className="col-form-label required">
                            {t("Zip Code")}{" "}
                            <Tooltip content={t("Zipcode_Tooltip")}>
                              <i className="fa fa-light fa-circle-info"></i>
                            </Tooltip>
                          </label>
                          <input
                            className="form-control"
                            placeholder="Zip code"
                            type="Number"
                            name="zipcode"
                            {...register("zipcode", {
                              onChange: (e) => {
                                setZipCode(e.target.value);
                              },
                              required: true,
                            })}
                            // onChange={(e) => setZipCode(e.target.value)}
                          />
                          <div className="invalid-feedback">
                            {errors.zipcode?.type === "required" &&
                              "Zip Code is required"}
                          </div>
                        </div>
                      </div>

                      <div className="form-group row">
                        <div className="col-sm-6">
                          <label className="col-form-label required">
                            {t("Tax Region")}{" "}
                            <Tooltip content={t("TaxRegion_Tooltip")}>
                              <i className="fa fa-light fa-circle-info"></i>
                            </Tooltip>
                          </label>
                          <input
                            placeholder={t("Tax Region")}
                            className="form-control"
                            type="text"
                            //   value={serial_number}
                            // onChange={(e) => setTaxRegion(e.target.value)}
                            name="taxregion"
                            id="taxregion"
                            {...register("taxregion", {
                              onChange: (e) => {
                                setTaxRegion(e.target.value);
                              },
                              required: true,
                            })}
                          />
                          <div className="invalid-feedback">
                            {errors.taxregion?.type === "required" &&
                              "Tax Region is required"}
                          </div>
                        </div>
                        <div className="col-sm-6">
                          <label className="col-form-label">
                            {t("Combined Rate")}{" "}
                            <Tooltip content={t("CombinedRate_Tooltip")}>
                              <i className="fa fa-light fa-circle-info"></i>
                            </Tooltip>
                          </label>
                          <input
                              value={combinedrate}
                            onChange={(e) => setCombinedRate(e.target.value)}
                            type="number"
                            disabled
                            id="Combined rate"
                            className="form-control"
                            placeholder="Combined Rate"
                          />
                        </div>
                      </div>

                      <div className="form-group row">
                        <div className="col-sm-6">
                          <label className="col-form-label">
                            {t("State Rate")}{" "}
                            <Tooltip content={t("StateRate_Tooltip")}>
                              <i className="fa fa-light fa-circle-info"></i>
                            </Tooltip>
                          </label>
                          <input
                              value={staterate}
                            className="form-control no-spinner"
                            onChange={(e) => setStateRate(e.target.value)}
                            type="number"
                            step="0.00001"
                            min="0"
                            id="State Rate"
                            placeholder="State Rate"
                          />
                        </div>
                        <div className="col-sm-6">
                          <label className="col-form-label">
                            {t("County Rate")}{" "}
                            <Tooltip content={t("CountyRate_Tooltip")}>
                              <i className="fa fa-light fa-circle-info"></i>
                            </Tooltip>
                          </label>
                          <input
                            className="form-control no-spinner"
                            value={countyrate}
                            onChange={(e) => setCountyRate(e.target.value)}
                            type="number"
                            name="Countyrate"
                            id="model"
                            step="0.00001"
                            min="0"
                            placeholder="County Rate"
                          />
                        </div>
                      </div>

                      <div className="form-group row">
                        <div className="col-sm-6">
                          <label className="col-form-label">
                            {t("City Rate")}{" "}
                            <Tooltip content={t("CityRate_Tooltip")}>
                              <i className="fa fa-light fa-circle-info"></i>
                            </Tooltip>
                          </label>
                          <input
                            className="form-control no-spinner"
                            value={cityrate}
                            onChange={(e) => setCityRate(e.target.value)}
                            type="Number"
                            id="CityRate"
                            step="0.00001"
                            min="0"
                            placeholder="City Rate"
                          />
                        </div>
                        <div className="col-sm-6">
                          <label className="col-form-label">
                            {t("Special Rate")}{" "}
                            <Tooltip content={t("SpecialRate_Tooltip")}>
                              <i className="fa fa-light fa-circle-info"></i>
                            </Tooltip>
                          </label>
                          <input
                            className="form-control no-spinner"
                            value={specialrate}
                            onChange={(e) => setSpecialRate(e.target.value)}
                            type="Number"
                            step="0.00001"
                            min="0"
                            id="Spical Rate"
                            placeholder="Special Rate"
                          />
                        </div>
                        <div className="col-sm-6">
                          <label className="col-form-label required">
                            {t("Start Date")}{" "}
                            <Tooltip content={t("StartDate_Tooltip")}>
                              <i className="fa fa-light fa-circle-info"></i>
                            </Tooltip>
                          </label>
                          <DatePicker
                            {...register("startDate", { required: true })}
                            className="form-control datepick"
                            selected={startDate}
                            name="startDate"
                            onChange={(e) => dateplace_Date(e)}
                            placeholderText={"mm/dd/yyyy"}
                            scrollableYearDropdown
                            showMonthDropdown
                            showYearDropdown
                            scrollableMonthYearDropdown
                            dropdownMode="select"
                          />
                          <div className="invalid-feedback">
                            {errors.startDate && "Start Date  is required"}
                          </div>
                        </div>
                        <div className="col-sm-6">
                          <label className="col-form-label">
                            {t("End Date")}{" "}
                            <Tooltip content={t("EndDate_Tooltip")}>
                              <i className="fa fa-light fa-circle-info"></i>
                            </Tooltip>
                          </label>
                          <DatePicker
                            className="form-control datepick"
                            selected={endDate}
                            name="enddate"
                            onChange={(e) => enddateplace_Date(e)}
                            placeholderText={"mm/dd/yyyy"}
                            scrollableYearDropdown
                            showMonthDropdown
                            showYearDropdown
                            scrollableMonthYearDropdown
                            dropdownMode="select"
                          />
                        </div>
                      </div>

                      <div className="text-left  py-4 ">
                        <Link to={"/taxrateview"}>
                          <button
                            type="button"
                            className="btn btn-secondary btn-md"
                          >
                            {t("Cancel")}
                          </button>
                          &nbsp;&nbsp;
                        </Link>
                        <button
                          type="submit"
                          disabled={disable}
                          className="border-0 btn btn-primary btn-gradient-primary btn-md"
                        >
                          {loading === false ? t("Save") : <ButtonLoading />}
                        </button>
                        &nbsp;&nbsp;
                      </div>
                    </>
                  }
                  <CheckButton style={{ display: "none" }} ref={checkBtn} />
                </Form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AddTaxRate;
